import { create } from "zustand";

export type LibraryTab = "all" | "extension" | "archived";

interface Store {
	/** Which library tab is shown: All / From extension / Archived */
	libraryTab: LibraryTab;
	setLibraryTab: (tab: LibraryTab) => void;

	activeAllPage: number;
	setActiveAllPage: (page: number) => void;

	/** Page of the "From extension" tab (creationMode=SELECTION) */
	activeExtensionPage: number;
	setActiveExtensionPage: (page: number) => void;

	activeArchivedPage: number;
	setActiveArchivedPage: (page: number) => void;
}

export const useContentCacheStore = create<Store>(set => ({
	libraryTab: "all",
	setLibraryTab: tab => set({ libraryTab: tab }),

	activeAllPage: 1,
	setActiveAllPage: page => set({ activeAllPage: page }),

	activeExtensionPage: 1,
	setActiveExtensionPage: page => set({ activeExtensionPage: page }),

	activeArchivedPage: 1,
	setActiveArchivedPage: page => set({ activeArchivedPage: page }),
}));
